import { getBaseUrl, handleError, handleImportResponse, handleResponse } from "./apiUtils";

import { toast } from "react-toastify";

const baseUrl = getBaseUrl();

export async function importSubcontractorHours(formData) {
  const requestUrl = `${baseUrl}/subcontractor/ImportSubcontractorHours`;

  return await fetch(requestUrl, {
    method: "POST",
    body: formData})
    .then(async (response) => {
      if (response.status !== 200) {
        toast.error(
          "There was a problem importing subcontractor hours. Please verify the document for import is formatted correctly."
        );
      }
      const jsonResponse = await response.json();

      if (jsonResponse.length === 0) {
        toast.success("Import Successful");
      } else {
        let textResponse = "";
        jsonResponse.forEach((rowWithError) => {
          if (rowWithError.rowIndex === 0) {
            textResponse = textResponse.concat(
              `${rowWithError.errorMessage}\n\n`
            );
          } else {
            textResponse = textResponse.concat(
              `Row: ${rowWithError.rowIndex} ${rowWithError.errorMessage}\n`
            );
          }
        });

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        var link = document.createElement("a");
        link.download = `Errors_${
          today.getMonth() + 1
        }_${today.getDate()}_${today.getFullYear()}.txt`;
        var blob = new Blob([textResponse], { type: "text/plain" });
        link.href = window.URL.createObjectURL(blob);
        link.click();
        link.remove();
        toast.error("Import Failed: Please see the attached file");
      };
    })
}